import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Reviews, IconReviewStar, Button, IconCollection } from '../';
import css from './StoreReviews.module.css';

const StoreReviews = ({ reviews, averageRating, totalReviews, title }) => {
    // Only render if required details are present
    if (!Array.isArray(reviews) || reviews.length === 0 || !averageRating || !totalReviews) return null;

    const [visibleCount, setVisibleCount] = useState(3);
    const showMore = visibleCount < reviews.length;

    return (
        <div className={css.root}>
            <div className={css.headerRow}>
                <h4 className={css.title}>{title || 'Store Reviews'}</h4>
                <div className={css.summary}>
                    <IconReviewStar className={css.starIcon} />
                    <span className={css.rating}>{averageRating.toFixed(1)}</span>
                    <span className={css.reviewCount}>({totalReviews} reviews)</span>
                </div>
            </div>
            <div className={css.reviewsList}>
                <Reviews reviews={reviews.slice(0, visibleCount)} rootClassName={css.reviews} />
            </div>
            {showMore && (
                <div className={css.moreBtnRow}>
                    <Button variant="info" arrow='right' icon={<IconCollection name="arrow_righ_stright" />} className={css.moreBtn} onClick={() => setVisibleCount(visibleCount + 3)}>
                        Read more reviews
                    </Button>
                </div>
            )}
        </div>
    );
};

StoreReviews.propTypes = {
    reviews: PropTypes.array.isRequired,
    averageRating: PropTypes.number.isRequired,
    totalReviews: PropTypes.number.isRequired,
    title: PropTypes.string,
};

export default StoreReviews; 